import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibrarySaveLessonNotification = props => {
	const library_type = props.library_type === 'school' ? localize('my_library_school_library') : localize('my_library_district_library')
	return (
		<Confirm
			btTwo={localize('global_ok')}
			alertMessage={localize('my_library_save_lesson_message') + ' ' + library_type}
			actionButtonType={0}
			actionTwo={() => {
				props.actions.closeSaveConfirm()
			}}
			closeAction={() => {
				props.actions.closeSaveConfirm()
			}}
		/>
	)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeSaveConfirm: myLibraryActions.closeSaveLessonNotification,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibrarySaveLessonNotification)
